<template>
  <div class="form-group background-content-wrapper" v-click-outside="bgContentDeselected">

    <draggable
      v-model="editableBgContent"
      v-bind="dragOptions"
      class="background-content-list"
      @end="updateBgContent"
    >
      <div 
        v-for="(background, index) in editableBgContent" 
        :key="index" 
        class="background-content"
        :class="{'background-content--no-bg' : background.asset.isEmpty}"
        @click="bgContentSelected($event, background)"
      >
        <div v-if="background.heading[lang] != ''" class="heading" v-html="background.heading[lang]"></div>
        <img v-if="background.asset && background.asset.thumbPath" :src="$store.state.assetsPath + background.asset.thumbPath" alt="">

      </div>
    </draggable>

    <button type="button" class="btn btn-secondary" @click="addBgContent">
      Add Background
    </button>

    <!-- popup modal for background content -->
    <modal-edit-box 
      :isVisible="isBgContentSelected"
      :isArrowVisible="true"
      :xPos="modalData.xPos"
      :yPos="modalData.yPos"
      @update="updateBgContent"
      @remove="removeBgContent(modalData._id)"
    >
      <fieldset slot="input" class="form-group form-group--sm">
        <label class="modal-label">Heading</label>
        <input
          v-model="modalData.heading[lang]"
          type="text"
          class="form-control form-control-lg"
          placeholder="heading"
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm mb-1">
        <input
          v-if="modalData.assetPath"
          v-model="modalData.assetPath"
          type="text"
          class="form-control form-control-lg"
          placeholder="no asset attached"
          readonly
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-secondary btn-block btn-sm"
          @click="openAssetLibrary"
        >Attach Asset</button>
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-danger btn-block btn-sm"
          @click="removeAsset"
        >Remove Asset</button>
      </fieldset>
    </modal-edit-box>
    <!-- popup modal -->

    <asset-library
      v-if="isLibraryVisible"
      v-model="libraryModel"
      :multiple="false"
      defaultCategory="pageBackground"
      @close="closeAssetLibrary"
    ></asset-library>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import AssetLibrary from '@/components/NewAssetLibrary'

export default {
  name: 'page-bg-content',

  components: {
    draggable,
    AssetLibrary
  },

  props: ['bgContent', 'dir', 'lang', 'isSlider'],

  data() {
    return {
      editableBgContent: this.bgContent,

      isBgContentSelected: false,

      modalData: {
        heading: {},
        asset: {},
        assetId: null
      },

      isLibraryVisible: false,
      libraryModel: null
    }
  },

  watch: {
    libraryModel () {
      if (this.libraryModel) {
        this.modalData.assetId = this.libraryModel._id
        this.modalData.asset = this.libraryModel
      }
    },

    assets () {
      this.initLibraryModel()
    },

    value () {
      if (this.libraryModel) {
        if (this.multiple) {
          const libraryModelPaths = JSON.stringify(this.libraryModel.map(asset => {
            return asset.path
          }))
          const valuePaths = JSON.stringify(this.value)
          if (libraryModelPaths !== valuePaths) {
            this.initLibraryModel ()
          }
        } else {
          if (this.value !== this.libraryModel.path) {
            this.initLibraryModel ()
          }
        }
      } else {
        this.initLibraryModel()
      }
    }
  },

  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },

    dragOptions() {
      return {
        animation: 120,
        group: "contentBg",
        disabled: false,
        ghostClass: "ghostly"
      }
    },

    highestId () {
      let ids = [0];

      this.editableBgContent.forEach((bg) => {
        if (!isNaN(bg._id)) {
          ids.push(bg._id)
        }        
      });

      return (Math.max(...ids) + 1).toString();
    },
  },

  // mounted() {
  //   // load the thumbnails
  //   this.editableBgContent.forEach((bg, i) => {
  //     this.setThumbnailPath(bg.assetId, i)
  //   })
  // },

  methods: {
   addBgContent() {
      const newBgContent = {
        _id: this.highestId,
        heading: {
          en: ''
        },
        assetId: null,
        asset: { isEmpty: true }
      }

      this.editableBgContent.push(newBgContent)
    },

    updateBgContent() {
      this.isBgContentSelected = false;
      this.$emit('updateBgContent', this.editableBgContent)

      // this.editableBgContent.forEach((bg, i) => {
      //   this.setThumbnailPath(bg.assetId, i)
      // })
    },

    removeBgContent(id) {
      this.isBgContentSelected = false;

      let remainingBgContent = this.editableBgContent.filter(function(item) {
        if (item._id != id) {
          return item
        }
      });

      this.editableBgContent = remainingBgContent
      this.$emit('updateBgContent', this.editableBgContent)
    },

    bgContentSelected(event, item) {
      this.isBgContentSelected = true;

      const modalWidth = 125;

      let modalLeft = event.target.offsetLeft + (modalWidth / 2);
      let modalTop = event.target.offsetTop + event.target.offsetHeight + 7;

      this.modalData = item
      this.modalData.xPos = modalLeft
      this.modalData.yPos = modalTop
    },

    bgContentDeselected() {
      this.isBgContentSelected = false;
    },

    closeAssetLibrary () {
      this.isLibraryVisible = false
    },

    openAssetLibrary () {
      if (!this.disabled)
        this.isLibraryVisible = true
    },

    initLibraryModel () {
      if (this.assets.length) {
        if (this.multiple) {
          let libraryModel = []
          this.value.forEach(path => {
            libraryModel.push(_.find(this.assets, asset => {
              return asset.path === path
            }))
          })
          this.libraryModel = libraryModel
        } else {
          this.libraryModel = _.find(this.assets, asset => {
            return asset.path === this.value
          })
        }
      }
    },

    removeAsset () {
      this.modalData.assetId = null
      this.modalData.asset = { isEmpty: true }
    },

    // setThumbnailPath (assetId, index) {
    //   const basePath = this.$store.state.assetsPath
    //   const assets = this.$store.state.assetLibrary.assets
    //   let thumbnailPath = ''

    //   // get asset by id
    //   assets.forEach(asset => {
    //     if (asset._id === assetId) {
    //       this.editableBgContent[index].assetPath = asset.path
    //       this.editableBgContent[index].assetThumbPath = asset.customThumbPath ? asset.customThumbPath : asset.thumbPath
    //     }
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>

.background-content-wrapper {
  position: relative;
}

.background-content-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.background-content {
  background-size: cover;
  border-radius: 4px;
  cursor: move;
  font-size: 2.5px;
  height: calc(980px / 4);
  margin: 10px;
  overflow: hidden;
  position: relative;
  width: calc(1520px / 4);

  &--no-bg {
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: 
    linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%),
    linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
  }

  img {
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    user-select: none;
    width: 100%;
  }

  .heading {
    font-size: 5em;
    font-weight: 500;
    color: #fff;
    position: absolute;
    top: 1em;
    left: 1em;
    letter-spacing: .1em;
    line-height: 1;
    padding-top: .5em;
    text-shadow: 0 0 5px rgba(0,0,0,.5);

    &::before {
      content: "";
      width: 2.5em;
      height: .25em;
      background-color: #2faae1;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.modal-label {
  color: #ffffff;
}
</style>